
import { randomArrayElement } from '../utils'

const list = [
  'abstinence',
  'alcoholism',
  'artificial intelligence',
  'augmented reality',
  'automation',
  'bedrooms',
  'big data',
  'bicycles',
  'birth control',
  'blockchain',
  'books',
  'buildings',
  'cabins',
  'cheese',
  'clothing',
  'comedians',
  'conception',
  'content marketing',
  'data mining',
  'data visualization',
  'depression',
  'dogs',
  'drunkenness',
  'enlightenment',
  'facsimile',
  'farming',
  'firearms',
  'fusion',
  'gambling',
  'hamburgers',
  'hotels',
  'houses',
  'house cleaning',
  'jogging',
  'lawn care',
  'lunch',
  'machine learning',
  'mainframes',
  'mathematicians',
  'metaphysics',
  'networking',
  'nutrition',
  'politics',
  'porn',
  'pottery',
  'priesthood',
  'quilting',
  'sadomasochism',
  'sarcasm',
  'shoes',
  'shopping',
  'sports',
  'snacks',
  'taxes',
  'the outdoors',
  'tampons',
  'therapy',
  'third-world countries',
  'vaccinations',
  'virtual reality',
  'weight loss',
  'whisky'
]

export const get = () => randomArrayElement(list)
